import $ from 'jquery';
import horizontalScrollmenu from './horizontal-scroll-menu';
import heartProduct from "modules/heart-product";
// var searchDesigner = require('./search-designer');
import './search-designer';

function bindHeartItems() {
  heartProduct('#pageItems', '.fav-item');
}

function initHorizontalScrollmenu() {
  horizontalScrollmenu();
}

$(document).ready(function() {
  if($('.js-scroll-menu').length) {
    initHorizontalScrollmenu();
  }
  $('.js-favorite-designer').on('click', function() {
    $(this).toggleClass('favorite-button--heart-active');
  });
  bindHeartItems();
  $('.js-trigger-search-designer').searchDesigner();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/designers/index.js